<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">   
      <div class="backborder2 shop-sale-table" v-loading="query.loading">
	  	<span class="shop-sales-title">基本信息</span>
		<table>
			<tr>
				<td rowspan="3" colspan="1" align="center">
					<div style="width:70px;height:70px;border:1px solid #dddddd;background:#dddddd;border-radius:50%;overflow:hidden">
					<img :src="this.GLOBAL.staticUrl+shopinfos.thumb" style="float:left;width:100%;border-radius:5px" v-if="shopinfos.thumb!=''" />
					<img src="../../assets/shop.png" style="float:left;width:100%;border-radius:5px" v-if="shopinfos.thumb==''"/>
					</div>
				</td>
				<td class="shoptitle" colspan="1">店铺名称</td>
				<td colspan="4">{{shopinfos.shopname}}</td>
				<td class="shoptitle" colspan="1">创始人</td>
				<td colspan="4">{{shopinfos.truename}}</td>		
			</tr>
			<tr>
				<td class="shoptitle" colspan="1">店铺地址</td>
				<td colspan="4">{{shopinfos.address}}</td>
				<td class="shoptitle" colspan="1">创始人手机号</td>
				<td colspan="4">{{shopinfos.phone}}</td>	
			</tr>
			<tr>
				<td class="shoptitle" colspan="1">用户标签</td>
				<td colspan="9">
				<el-tag type="danger" size="small" v-for="(item,index) in shopinfos.labellists" :key="index" style="margin:0 10px 10px 0" closable @close="dellabels(item,index)">{{item.name}}</el-tag>
				<el-button type="warning" size="mini" round style="float:right" @click="settinglabels">设置标签</el-button>
				</td>
			</tr>
		</table>
	  </div>

	  <div class="backborder2 shop-sale-table" style="margin-top:10px" v-loading="statquery.loading">
	    <span class="shop-sales-title">订单信息统计</span>
		<table>
			<tr>
				<td class="shoptitle" align="center">总实付金额</td>
				<td class="shoptitle" align="center">下单数量</td>
				<td class="shoptitle" align="center">客单价</td>
				<td class="shoptitle" align="center">最后一次下单时间</td>	
			</tr>
			<tr>
				<td align="center">￥{{statinfos.reals}}</td>
				<td align="center">{{statinfos.ordernumber}}</td>
				<td align="center">￥{{statinfos.average}}</td>
				<td align="center">{{statinfos.lasttime}}</td>	
			</tr>
			<tr>
				<td class="shoptitle" align="center">退货记录</td>
				<td class="shoptitle" align="center">店铺成员下单统计</td>
				<td class="shoptitle" align="center">商品采购统计</td>
				<td class="shoptitle" align="center">品牌采购统计</td>	
			</tr>
			<tr>
				<td align="center"><el-button type="warning" size="mini" round @click="refundlogs">查看</el-button></td>
				<td align="center"><el-button type="warning" size="mini" round @click="memberlogs">查看</el-button></td>
				<td align="center"><el-button type="warning" size="mini" round @click="goodslogs">查看</el-button></td>
				<td align="center"><el-button type="warning" size="mini" round @click="brandlogs">查看</el-button></td>	
			</tr>
		</table>
	  </div>

	  <div class="backborder2 shop-sale-table" style="margin-top:10px">
	      <span class="shop-sales-title">下单统计柱状图</span>
		  <el-form :inline="true" class="demo-form-inline" size="mini" style="margin-top:10px">
		  	  <el-form-item style="width:15%">
				<el-select v-model="shopstatviewquery.type" remote  filterable placeholder="时间类型">
					<el-option v-for="(item,index) in typelist" :label="item.name" :value="item.id" :key="index" />
				</el-select>
			  </el-form-item>
			  <el-form-item>
				  <el-date-picker v-model="shopstatviewquery.stime" type="month" format="yyyy-MM" value-format="yyyy-MM-dd" placeholder="选择月" style="width:30%"/>
				  <el-date-picker v-model="shopstatviewquery.etime" type="month" format="yyyy-MM" value-format="yyyy-MM-dd" placeholder="选择月" style="width:30%"/>
			  	  <el-button type="warning" size="mini" round icon="el-icon-search" @click="getcustano" style="margin-left:10px">搜索</el-button>
			  </el-form-item>
		  </el-form>
		  
		  <div class="brand" style="margin-top:10px">
        	  <IEcharts :option="brand" :loading="custnaoLoading"/>
		  </div>

	  </div>

	  <div class="backborder2 shop-sale-table" style="margin-top:10px;margin-bottom:20px" v-loading="orderlogisticsquery.loading">
	      <span class="shop-sales-title">历史订单记录</span>
		  <table>
			<tr>
				<td class="shoptitle" align="center">订单号</td>
				<td class="shoptitle" align="center">订单金额</td>
				<td class="shoptitle" align="center">实付金额</td>
				<td class="shoptitle" align="center">支付方式</td>
				<td class="shoptitle" align="center">收货人</td>
				<td class="shoptitle" align="center">联系电话</td>
				<td class="shoptitle" align="center">下单时间</td>
				<td class="shoptitle" align="center">订单状态</td>	
			</tr>
			<tr v-for="(item,index) in orderlogisticslists" :key="index">
				<td align="center">{{item.ordernumber}}</td>
				<td align="center">{{item.totals}}</td>
				<td align="center">{{item.prices}}</td>
				<td align="center">{{item.paytype}}</td>
				<td align="center">{{item.truename}}</td>
				<td align="center">{{item.phone}}</td>
				<td align="center">{{item.time}}</td>
				<td align="center">{{item.status}}</td>	
			</tr>
		  </table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
	              @size-change="orderlogpageSizeChange"
	              @current-change="orderlogpageCurrentChange"
	              :current-page="orderlogisticsquery.p"
	              :page-sizes="[10, 20, 50]"
	              :page-size="orderlogisticsquery.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="order_row_totals">
	          </el-pagination>
	          <!--分页end-->
	      </div>
	  </div>

	  <!-- 店铺标签设置 -->
	  <el-dialog title="店铺标签设置" :visible.sync="labelmanagerDialog" width="40%" top="10vh">
		  <el-table :data="allabellists" v-loading="labelloading">
		  	  <el-table-column label="id" prop="id" align="center" />
	          <el-table-column label="标签名称" prop="name" align="left" />
			  <el-table-column label="操作" align="center">
				  <template slot-scope="scope">
		            <el-button :type="scope.row.isselect==0 ? 'info' : 'success'" size="mini" icon="el-icon-check" circle @click="selectordellabel(scope.row,scope.$index)" />
		          </template>
			  </el-table-column>
	      </el-table>
		  <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="labelmanagerDialog = false">取 消</el-button>
			  <el-button type="danger" size="small" @click="saveeditlabels">保 存</el-button>
          </div>
	  </el-dialog>
	  
	  <!-- 退货纪录 -->
	  <el-dialog title="退货记录" :visible.sync="refundlogDialog" width="80%" top="10vh">
	    <el-radio-group v-model="refundlogquery.type" size="small" @change="changerefundlog">
			<el-radio-button label="1">按订单</el-radio-button>
			<el-radio-button label="2">按商品</el-radio-button>
		</el-radio-group>
		<div class="shop-sale-table" v-loading="refundlogquery.loading">
			<table>
			<tr>
				<td class="shoptitle" align="center" v-if="refundlogquery.type==1">订单号</td>
				<td class="shoptitle" align="center" v-if="refundlogquery.type==1">可退金额</td>
				<td class="shoptitle" align="center" v-if="refundlogquery.type==1">退款金额</td>
				<td class="shoptitle" align="center" v-if="refundlogquery.type==1">下单时间</td>
				<td class="shoptitle" align="center" v-if="refundlogquery.type==1">退款时间</td>
				<td class="shoptitle" align="left" v-if="refundlogquery.type==2">商品名称</td>
				<td class="shoptitle" align="left" v-if="refundlogquery.type==2">所属品牌</td>
				<td class="shoptitle" align="center" v-if="refundlogquery.type==2">订单号</td>
				<td class="shoptitle" align="center" v-if="refundlogquery.type==2">可退数量</td>
				<td class="shoptitle" align="center" v-if="refundlogquery.type==2">可退金额</td>
				<td class="shoptitle" align="center" v-if="refundlogquery.type==2">退货数量</td>
				<td class="shoptitle" align="center" v-if="refundlogquery.type==2">退款金额</td>
				<td class="shoptitle" align="center" v-if="refundlogquery.type==2">下单时间</td>
				<td class="shoptitle" align="center" v-if="refundlogquery.type==2">退款时间</td>	
			</tr>
			<tr v-for="(item,index) in refundlists" :key="index">
				<td align="center" v-if="refundlogquery.type==1">{{item.ordernumber}}</td>
				<td align="center" v-if="refundlogquery.type==1">{{item.allprice}}</td>
				<td align="center" v-if="refundlogquery.type==1">{{item.allrefund}}</td>
				<td align="center" v-if="refundlogquery.type==1">{{item.paytime}}</td>
				<td align="center" v-if="refundlogquery.type==1">{{item.edittime}}</td>
				<td align="left" v-if="refundlogquery.type==2">
					<span style="float:left;width:100%">{{item.productname}}</span>
					<span style="float:left;width:100%;font-size:12px;color:#999999">规格：（{{item.propertyname}}）</span>
				</td>
				<td align="left" v-if="refundlogquery.type==2">{{item.brandname}}</td>
				<td align="center" v-if="refundlogquery.type==2">{{item.ordernumber}}</td>
				<td align="center" v-if="refundlogquery.type==2">{{item.basenum}}</td>
				<td align="center" v-if="refundlogquery.type==2">{{item.reals}}</td>
				<td align="center" v-if="refundlogquery.type==2">{{item.numbers}}</td>
				<td align="center" v-if="refundlogquery.type==2">{{item.refundprice}}</td>
				<td align="center" v-if="refundlogquery.type==2">{{item.paytime}}</td>
				<td align="center" v-if="refundlogquery.type==2">{{item.edittime}}</td>
			</tr>
		  </table>
		  <div class="block">
	          <!--分页begin-->
	          <el-pagination
	              @size-change="refundlogpageSizeChange"
	              @current-change="refundlogpageCurrentChange"
	              :current-page="refundlogquery.p"
	              :page-sizes="[10, 20, 50]"
	              :page-size="refundlogquery.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="refund_total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
		</div>
	  </el-dialog>


	  <!-- 店铺成员销售信息 -->
	  <el-dialog title="店铺成员销售信息" :visible.sync="memberlogDialog" width="80%" top="10vh">
	  	<el-form :inline="true" class="demo-form-inline" size="small">
			<el-form-item>
			    <el-select v-model="memberlogquery.ordertype" remote  filterable @change="ismemberchange=true">
	          	    <el-option v-for="(item,index) in ordertypelists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select> 
          	</el-form-item>
			<el-form-item>
			    <el-select v-model="memberlogquery.sort" remote  filterable @change="ismemberchange=true">
	          	    <el-option v-for="(item,index) in sortlists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select> 
          	</el-form-item>
			<el-form-item>
			   <el-input  placeholder="请输入店员名称 / 手机号" type="text" clearable v-model="memberlogquery.key" @change="ismemberchange=true"/>
            </el-form-item>
			<el-form-item>
			   <el-button type="primary" size="small" round icon="el-icon-search" @click="getmemberlogs">搜索</el-button>
			</el-form-item>
		</el-form>
		<div class="shop-sale-table" v-loading="memberlogquery.loading">
			<table>
			<tr>
				<td class="shoptitle" align="left">姓名</td>
				<td class="shoptitle" align="left">联系电话</td>
				<td class="shoptitle" align="center">总消费金额</td>
				<td class="shoptitle" align="center">下单数量</td>
				<td class="shoptitle" align="center">客单价</td>
				<td class="shoptitle" align="center">最后一次下单时间</td>	
			</tr>
			<tr v-for="(item,index) in memberloglists" :key="index">
				<td align="left">{{item.truename}}</td>
				<td align="left">{{item.phone}}</td>
				<td align="center">{{item.reals}}</td>
				<td align="center">{{item.nums}}</td>
				<td align="center">{{item.average}}</td>
				<td align="center">{{item.time}}</td>
			</tr>
		  </table>
		  <div class="block">
	          <!--分页begin-->
	          <el-pagination
	              @size-change="memberlogpageSizeChange"
	              @current-change="memberlogpageCurrentChange"
	              :current-page="memberlogquery.p"
	              :page-sizes="[10, 20, 50]"
	              :page-size="memberlogquery.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="member_total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
		</div>
	  </el-dialog>


	  <!-- 商品销售信息 -->
	  <el-dialog title="商品销售信息" :visible.sync="goodslogDialog" width="80%" top="10vh">
	  	<el-form :inline="true" class="demo-form-inline" size="small">
			<el-form-item>
			    <el-select v-model="goodslogquery.ordertype" remote  filterable @change="isgoodschange=true">
	          	    <el-option v-for="(item,index) in goodstypelists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select> 
          	</el-form-item>
			<el-form-item>
			    <el-select v-model="goodslogquery.sort" remote  filterable @change="isgoodschange=true">
	          	    <el-option v-for="(item,index) in goodssortlists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select> 
          	</el-form-item>
			<el-form-item>
			   <el-input  placeholder="请输入商品名称" type="text" clearable v-model="goodslogquery.key" @change="isgoodschange=true"/>
            </el-form-item>
			<el-form-item>
			   <el-button type="warning" size="small" round icon="el-icon-search" @click="getgoodslogs">搜索</el-button>
			</el-form-item>
		</el-form>
		<div class="shop-sale-table" v-loading="goodslogquery.loading">
			<table>
			<tr>
				<td class="shoptitle" align="left">商品名称</td>
				<td class="shoptitle" align="left">品牌</td>
				<td class="shoptitle" align="center">采购次数</td>
				<td class="shoptitle" align="center">采购总数量</td>
				<td class="shoptitle" align="center">采购总金额</td>
				<td class="shoptitle" align="center">最后一次下单时间</td>	
			</tr>
			<tr v-for="(item,index) in goodsloglists" :key="index">
				<td align="left">{{item.productname}}</td>
				<td align="left">{{item.brandname}}</td>
				<td align="center">{{item.nums}}</td>
				<td align="center">{{item.numbers}}</td>
				<td align="center">{{item.reals}}</td>
				<td align="center">{{item.time}}</td>
			</tr>
		  </table>
		  <div class="block">
	          <!--分页begin-->
	          <el-pagination
	              @size-change="goodslogpageSizeChange"
	              @current-change="goodslogpageCurrentChange"
	              :current-page="goodslogquery.p"
	              :page-sizes="[10, 20, 50]"
	              :page-size="goodslogquery.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="goods_total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
		</div>
	  </el-dialog>


	  <!-- 品牌销售信息 -->
	  <el-dialog title="商品销售信息" :visible.sync="brandlogDialog" width="80%" top="10vh">
	  	<el-form :inline="true" class="demo-form-inline" size="small">
			<el-form-item>
			    <el-select v-model="brandlogquery.ordertype" remote  filterable @change="isbrandchange=true">
	          	    <el-option v-for="(item,index) in brandtypelists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select> 
          	</el-form-item>
			<el-form-item>
			    <el-select v-model="brandlogquery.sort" remote  filterable @change="isbrandchange=true">
	          	    <el-option v-for="(item,index) in brandsortlists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select> 
          	</el-form-item>
			<el-form-item>
			   <el-input  placeholder="请输入商品名称" type="text" clearable v-model="brandlogquery.key" @change="isbrandchange=true"/>
            </el-form-item>
			<el-form-item>
			   <el-button type="primary" size="small" round icon="el-icon-search" @click="getbrandlogs">搜索</el-button>
			</el-form-item>
		</el-form>
		<div class="shop-sale-table" v-loading="brandlogquery.loading">
			<table>
			<tr>
				<td class="shoptitle" align="left">品牌名称</td>
				<td class="shoptitle" align="center">采购商品数</td>
				<td class="shoptitle" align="center">采购次数</td>
				<td class="shoptitle" align="center">采购总数量</td>
				<td class="shoptitle" align="center">采购金额</td>
				<td class="shoptitle" align="center">最后一次下单时间</td>	
			</tr>
			<tr v-for="(item,index) in brandloglists" :key="index">
				<td align="left">{{item.brandname}}</td>
				<td align="center">{{item.goodsnums}}</td>
				<td align="center">{{item.nums}}</td>
				<td align="center">{{item.numbers}}</td>
				<td align="center">{{item.reals}}</td>
				<td align="center">{{item.time}}</td>
			</tr>
		  </table>
		  <div class="block">
	          <!--分页begin-->
	          <el-pagination
	              @size-change="brandlogpageSizeChange"
	              @current-change="brandlogpageCurrentChange"
	              :current-page="brandlogquery.p"
	              :page-sizes="[10, 20, 50]"
	              :page-size="brandlogquery.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="brand_total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
		</div>
	  </el-dialog>



  </div>
  </transition>  
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full.js';
export default {
  props:['childdata'],
  data () {
    return {
        url:this.GLOBAL.domain+"Shop/index",
        transitionshow:true,
        actionauth:'', //功能权限
		query: {
			act:'getshopbase',
			token:this.$cookies.get('token'),
			loading:false,
			shopid:this.childdata.id
		},
		shopinfos: {
			thumb:'',
			shopname:'',
			truename:'',
			phone:'',
			address:'',
			labellists:[],
		},
		statquery: {
			act:'getshopstat',
			token:this.$cookies.get('token'),
			loading:false,
			shopid:this.childdata.id
		},
		statinfos: {
			reals:'',
			ordernumber:'',
			average:'',
			lasttime:''
		},
		labelmanagerDialog:false,
		labelloading:false,
		allabellists:[],
		shopstatviewquery: {
			act:'getshopsalesview',
			shopid:this.childdata.id,
			token:this.$cookies.get('token'),
			loading:false,
			type:1,
			stime:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1),
			etime:new Date().getFullYear().toString()+'-'+(new Date().getMonth()+12),
		},
		typelist:[
			{id:1,name:'采购金额'},
			{id:2,name:'采购数量'},
		],
		orderlogisticsquery: {
			act:'getshopallorders',
			token:this.$cookies.get('token'),
			shopid:this.childdata.id,
			loading:false,
			p:1,
			rollpage:10
		},
		orderlogisticslists:[],
		order_row_totals:0,

		isrefundchange:false,
		refundlogDialog:false,
		refundlogquery: {
			act:'getrefundlog',
			token:this.$cookies.get('token'),
			type:1,
			shopid:this.childdata.id,
			loading:false,
			p:1,
			rollpage:10
		},
		refundlists:[],
		refund_total_rows:0,
		memberlogDialog:false,
		ismemberchange:false,
		memberlogquery: {
			act:'memberlog',
			token:this.$cookies.get('token'),
			shopid:this.childdata.id,
			ordertype:1,
			sort:2,
			key:'',
			loading:false,
			p:1,
			rollpage:10,
		},
		memberloglists:[],
		member_total_rows:0,
		ordertypelists:[
			{id:1,name:'按最后一次下单时间'},
			{id:2,name:'按总消费金额'},
			{id:3,name:'按下单数量'},
			{id:4,name:'按客单价'},
		],
		sortlists:[
			{id:1,name:'升序'},
			{id:2,name:'降序'}
		],
		goodstypelists:[
			{id:1,name:'按最后一次下单时间'},
			{id:2,name:'按下单次数'},
			{id:3,name:'按购买数量'},
			{id:4,name:'按购买总金额'},
		],
		goodssortlists:[
			{id:1,name:'升序'},
			{id:2,name:'降序'}
		],
		brandtypelists:[
			{id:1,name:'按最后一次下单时间'},
			{id:2,name:'按下单次数'},
			{id:3,name:'按购买数量'},
			{id:4,name:'按购买总金额'},
		],
		brandsortlists:[
			{id:1,name:'升序'},
			{id:2,name:'降序'}
		],

		goodslogDialog:false,
		isgoodschange:false,
		goodslogquery: {
			act:'goodssalestat',
			token:this.$cookies.get('token'),
			shopid:this.childdata.id,
			ordertype:1,
			sort:2,
			key:'',
			loading:false,
			p:1,
			rollpage:10,
		},
		goodsloglists:[],
		goods_total_rows:0,

		brandlogDialog:false,
		isbrandchange:false,
		brandlogquery: {
			act:'brandsalestat',
			token:this.$cookies.get('token'),
			shopid:this.childdata.id,
			ordertype:1,
			sort:2,
			key:'',
			loading:false,
			p:1,
			rollpage:10,
		},
		brandloglists:[],
		brand_total_rows:0,
		custnaoLoading:false,
		brand: {
          legend: {
			 data:['采购金额']
		  },
		  xAxis: {			  
			  type: 'category', // 还有其他的type，可以去官网喵两眼哦
			  data: [], // x轴数据
			  name: '', //x轴名称
			  nameTextStyle: { //x轴名称样式
			    fontWeight: 600,
			    fontSize: 18,
				width: 20,
			  }		  
		  },
		  yAxis: {
			  type: 'value',
			  name: '', //y轴名称
			  nameTextStyle: { //y轴名称样式
			    fontWeight: 600,
			    fontSize: 18
			  }    
		  },
		  tooltip: {
			  trigger: 'axis' //axis item none三个值
		  },
		  
		  series: [
			  {
			    name: '采购金额',
			    data: [],
			    type: 'bar',
				barGap: 0,
			    itemStyle : {
					normal : {
						color:'#E6A23C',
					}
				},
			  }
		  ]
        },

	}
  },

  components: {IEcharts},
  mounted(){    
    this.getactionauth();
	this.getshopbase(); //获取店铺基本信息
	this.getshopstats(); //获取店铺销售信息统计
	this.getshoplogisticsorders(); //获取店铺所有的下单记录
	this.getcustano(); //搜索柱状图
  },
  
  methods:{

	//获取功能权限
	getactionauth() {
		var data =this.$cookies.get('actionauth');
		data=JSON.parse(data);
		this.actionauth=data;
	},

	/** 获取下单店铺基本信息 **/
	getshopbase() {
		this.query.loading=true;
		var resource = this.$resource(this.url);
        resource.query(this.query).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.query.loading=false;
	        }else{
	            var result = JSON.parse(Base64.decode(res.data.Data));
				this.query.loading=false;
				this.shopinfos.thumb=result.thumb;
				this.shopinfos.shopname=result.shopname;
				this.shopinfos.address=result.address;
				this.shopinfos.truename=result.truename;
				this.shopinfos.phone=result.phone;
				this.shopinfos.labellists=result.labels;
	        }
        }).catch((res) => {
            this.query.loading=false;
        });
	},

	/** 获取店铺销售信息统计 **/
	getshopstats() {
		this.statquery.loading=true;
		var resource = this.$resource(this.url);
        resource.query(this.statquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.statquery.loading=false;
	        }else{
	            var result = JSON.parse(Base64.decode(res.data.Data));
				this.statinfos.reals=result.reals;
				this.statinfos.ordernumber=result.ordernumber;
				this.statinfos.average=result.average;
				this.statinfos.lasttime=result.lasttime;
				this.statquery.loading=false;
	        }
        }).catch((res) => {
            this.statquery.loading=false;
        });
	},

	/** 解绑店铺标签 **/
	dellabels(item,index) {
		this.query.loading=true;
		var resource = this.$resource(this.url);
		var shopids=[];
		shopids.push(this.query.shopid);
        resource.save({act:'editlabeltoshops',ids:shopids,labelid:item.id,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.query.loading=false;
	        }else{
	            this.query.loading=false;
				this.getshopbase();
	        }
        }).catch((res) => {
            this.query.loading=false;
        });
	},

	/** 设置标签 **/
	settinglabels() {
		this.labelmanagerDialog=true;
		this.labelloading=true;
		this.allabellists=[];
		var resource = this.$resource(this.url);
        resource.query({act:'getallshoplabels',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.labelloading=false;
	        }else{
	            this.allabellists = JSON.parse(Base64.decode(res.data.Data));
				var labelids=[];
				var _this=this;
				this.shopinfos.labellists.forEach(function(item,i) {labelids.push(item.id);});
				this.allabellists.forEach(function(item,i) {
					labelids.indexOf(item.id)==-1 ? item.isselect=0 : item.isselect=1;
				});
				this.labelloading=false;
	        }
        }).catch((res) => {
            this.labelloading=false;
        });
	},

	/** 选择、取消选择标签 **/
	selectordellabel(item,index) {
		var status=0;
		item.isselect==0 ? status=1 : status=0;
		this.allabellists[index].isselect=status;
		this.allabellists=JSON.parse(JSON.stringify(this.allabellists));
	},

	/** 店铺设置标签 **/
	saveeditlabels() {
		var ids=[];
		this.allabellists.forEach(function(item,index) {
			item.isselect==1 ? ids.push(item.id) : '';
		});
		var resource = this.$resource(this.url);
        resource.save({act:'shopsettinglabels',ids:ids,shopid:this.query.shopid,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.labelmanagerDialog=false;
				this.getshopbase();
	        }
        }).catch((res) => {
            
        });
	},

	/** 获取店铺所有历史下单记录 **/
	getshoplogisticsorders() {
		this.orderlogisticsquery.loading=true;
		var resource = this.$resource(this.url);
        resource.save(this.orderlogisticsquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.orderlogisticsquery.loading=false;
	        }else{
				this.orderlogisticsquery.loading=false;
				this.orderlogisticslists=[];
				this.orderlogisticslists = JSON.parse(Base64.decode(res.data.Data));
				this.order_row_totals=parseInt(res.data.count);
	        }
        }).catch((res) => {
            this.orderlogisticsquery.loading=false;
        });
	},

	orderlogpageSizeChange(val) {
        this.orderlogisticsquery.rollpage = val;
        this.getshoplogisticsorders();
    },
    orderlogpageCurrentChange(val) {
        this.orderlogisticsquery.p = val;
        this.getshoplogisticsorders();
    },


	/** 查看退货记录 **/
	refundlogs() {
		this.refundlogDialog=true;
		this.refundlogquery.type=1;
		this.refundlogquery.p=1;
		this.refundlogquery.rollpage=10;
		this.getrefundlogs();
	},

	//查询退货记录
	getrefundlogs() {
		if(this.isrefundchange) {
			this.refundlogquery.p=1;
			this.refundlogquery.rollpage=10;
		}

		this.refundlogquery.loading=true;
		var resource = this.$resource(this.url);
        resource.save(this.refundlogquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.refundlogquery.loading=false;
	        }else{
				this.refundlogquery.loading=false;
				this.refundlists=[];
				this.refundlists = JSON.parse(Base64.decode(res.data.Data));
				this.refund_total_rows=parseInt(res.data.count);
				if(this.isrefundchange) this.isrefundchange=false;
	        }
        }).catch((res) => {
            this.refundlogquery.loading=false;
        });
	},

	refundlogpageSizeChange(val) {
        this.refundlogquery.rollpage = val;
        this.getshoplogisticsorders();
    },
    refundlogpageCurrentChange(val) {
        this.refundlogquery.p = val;
        this.getshoplogisticsorders();
    },

	changerefundlog() {
		this.isrefundchange=true;
		this.getrefundlogs();
	},


	/** 店铺成员下单统计 **/
	memberlogs() {
		this.memberlogDialog=true;
		this.memberlogquery.ordertype=1;
		this.memberlogquery.sort=2;
		this.memberlogquery.key='';
		this.memberlogquery.p=1;
		this.memberlogquery.rollpage=10;
		this.getmemberlogs();
	},

	getmemberlogs() {
		if(this.ismemberchange) {
			this.memberlogquery.p=1;
			this.memberlogquery.rollpage=10;
		}

		this.memberlogquery.loading=true;
		var resource = this.$resource(this.url);
        resource.save(this.memberlogquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.memberlogquery.loading=false;
	        }else{
				this.memberlogquery.loading=false;
				this.memberloglists=[];
				this.memberloglists = JSON.parse(Base64.decode(res.data.Data));
				this.member_total_rows=parseInt(res.data.count);
				if(this.ismemberchange) this.ismemberchange=false;
	        }
        }).catch((res) => {
            this.memberlogquery.loading=false;
        });
	},

	memberlogpageSizeChange(val) {
        this.memberlogquery.rollpage = val;
        this.getmemberlogs();
    },
    memberlogpageCurrentChange(val) {
        this.memberlogquery.p = val;
        this.getmemberlogs();
    },

	/** 获取商品采购统计 **/
	goodslogs() {
		this.goodslogDialog=true;
		this.goodslogquery.ordertype=1;
		this.goodslogquery.sort=2;
		this.goodslogquery.key='';
		this.goodslogquery.p=1;
		this.goodslogquery.rollpage=10;
		this.getgoodslogs();
	},

	getgoodslogs() {
		if(this.isgoodschange) {
			this.goodslogquery.p=1;
			this.goodslogquery.rollpage=10;
		}

		this.goodslogquery.loading=true;
		var resource = this.$resource(this.url);
        resource.save(this.goodslogquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.goodslogquery.loading=false;
	        }else{
				this.goodslogquery.loading=false;
				this.goodsloglists=[];
				this.goodsloglists = JSON.parse(Base64.decode(res.data.Data));
				this.goods_total_rows=parseInt(res.data.count);
				if(this.isgoodschange) this.isgoodschange=false;
	        }
        }).catch((res) => {
            this.goodslogquery.loading=false;
        });
	},

	goodslogpageSizeChange(val) {
        this.goodslogquery.rollpage = val;
        this.getgoodslogs();
    },
    goodslogpageCurrentChange(val) {
        this.goodslogquery.p = val;
        this.getgoodslogs();
    },

	/** 获取品牌销售统计 **/
	brandlogs() {
		this.brandlogDialog=true;
		this.brandlogquery.ordertype=1;
		this.brandlogquery.sort=2;
		this.brandlogquery.key='';
		this.brandlogquery.p=1;
		this.brandlogquery.rollpage=10;
		this.getbrandlogs();
	},

	getbrandlogs() {
		if(this.isbrandchange) {
			this.brandlogquery.p=1;
			this.brandlogquery.rollpage=10;
		}

		this.brandlogquery.loading=true;
		var resource = this.$resource(this.url);
        resource.save(this.brandlogquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				this.brandlogquery.loading=false;
	        }else{
				this.brandlogquery.loading=false;
				this.brandloglists=[];
				this.brandloglists = JSON.parse(Base64.decode(res.data.Data));
				this.brand_total_rows=parseInt(res.data.count);
				if(this.isbrandchange) this.isbrandchange=false;
	        }
        }).catch((res) => {
            this.brandlogquery.loading=false;
        });
	},

	brandlogpageSizeChange(val) {
        this.brandlogquery.rollpage = val;
        this.getbrandlogs();
    },
    brandlogpageCurrentChange(val) {
        this.brandlogquery.p = val;
        this.getbrandlogs();
    },


	//获取客户统计信息
    getcustano() {
    	this.custnaoLoading=true;
    	var resource = this.$resource(this.url);
        resource.save(this.shopstatviewquery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.custnaoLoading=false;
            }else{
            	var _this=this;
                var result = JSON.parse(Base64.decode(res.data.Data));
				if(this.shopstatviewquery.type==1) {
					this.brand.legend.data[0]='采购金额';
					this.brand.series[0].name="采购金额";
				}
				if(this.shopstatviewquery.type==2) {
					this.brand.legend.data[0]='采购订单数量';
					this.brand.series[0].name="采购订单数量";
				}
                this.brand.xAxis.data=result.time; //时间段
                this.brand.series[0].data=result.data;                            
                this.custnaoLoading=false;
            }
        }).catch((res) => {
            this.custnaoLoading=false;
        });
    },


	/** 切换查询时间类型 **/
	changetimetype() {
		if(this.shopstatviewquery.type==2) {
			this.shopstatviewquery.stime=new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1);
			this.shopstatviewquery.etime=new Date().getFullYear().toString()+'-'+(new Date().getMonth()+12);

		}else if(this.shopstatviewquery.type==1) {
			this.shopstatviewquery.stime=new Date().getFullYear().toString();
			this.shopstatviewquery.etime=new Date().getFullYear().toString();

		}else if(this.shopstatviewquery.type==3) {
			

		}
	},

   } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.shop-sale-table {padding:1% 1% 1% 1% !important;}
.shop-sale-table table {width:100%;border-radius:5px;border-collapse:collapse;border-spacing:0;border-left:1px solid rgb(221,221,221,.6);border-top:1px solid rgb(221,221,221,.6);margin-top:10px}
.shop-sale-table table td {border-right:1px solid rgb(221,221,221,.6);border-bottom:1px solid rgb(221,221,221,.6);font-size:13px;padding:10px 15px;color:#606266;}
.shop-sale-table table .shoptitle {background:rgb(221,221,221,.3);font-weight:600}
.shop-sales-title {width:100%;font-size:13px;color:#606266;margin-bottom:10px;}
.brand {width:100%;height:300px;margin-top:10px}
</style>


// WEBPACK FOOTER //
// src/components/mall/mallsalesshopdetail.vue